import React from "react";
import {
  WhmBox,
  WhmCard,
  WhmCardContent,
  WhmSkeleton,
} from "@securitize/reactjs-whm";

export const SettingsLanguageLoadingCard: React.FC = () => (
  <WhmCard
    variant={"outlined"}
    data-test-id="profile-settings-top-skeleton-card"
    sx={{
      width: "100%",
      height: "fit-content",
    }}
  >
    <WhmCardContent>
      <WhmBox
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          paddingRight: "16px",
        }}
      >
        <WhmSkeleton variant="rounded" width={120} height={20} />
        <WhmSkeleton variant="rounded" width={"100%"} height={20} />
      </WhmBox>

      <WhmBox
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "8px",
          marginTop: "16px",
        }}
      >
        <WhmSkeleton variant="rounded" width={160} height={38} />
        <WhmSkeleton variant="rounded" width={160} height={38} />
      </WhmBox>
    </WhmCardContent>
  </WhmCard>
);
